var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotApproval = function SvgNotApproval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m67.91 41.809-21.445 4.91a4.5 4.5 0 1 1-2.01-8.773l21.446-4.91a4.5 4.5 0 0 1 2.009 8.773Zm-20.999 6.86a6.5 6.5 0 0 1-2.901-12.672l21.444-4.91a6.5 6.5 0 1 1 2.902 12.671l-21.445 4.91Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.505 31.532 44.01 35.998A4.5 4.5 0 0 1 42 27.224l19.496-4.464a4.5 4.5 0 0 1 2.01 8.772Zm-19.05 6.414a6.5 6.5 0 0 1-2.9-12.672L61.05 20.81a6.5 6.5 0 1 1 2.902 12.672l-19.496 4.464Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m60.075 21.033-18.52 4.241a4.5 4.5 0 1 1-2.01-8.773l18.521-4.24a4.5 4.5 0 0 1 2.01 8.772Zm-18.074 6.19a6.5 6.5 0 1 1-2.902-12.671L57.62 10.31a6.5 6.5 0 1 1 2.902 12.672L42 27.223Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.88 60.782.262.224a5.646 5.646 0 0 1 1.977 4.64l-.232 3.937a8.21 8.21 0 0 1-8.68 7.712 3.105 3.105 0 0 1-2.916-3.283l.527-8.928-7.716-13.405-.5-.27a17.932 17.932 0 0 1-8.557-10.247l-.774-2.368H10a8 8 0 0 1-8-8v-7a8 8 0 0 1 8-8h1.973l.524-1.2c2.78-6.36 9.125-10.8 16.503-10.8h7.798l7.929-1.816A20.178 20.178 0 0 0 42 1.794H29c-8.201 0-15.25 4.936-18.336 12H10c-5.523 0-10 4.477-10 10v7c0 5.522 4.477 10 10 10h3.82l.324.99a19.931 19.931 0 0 0 9.508 11.385l7.134 12.394-.492 8.331a5.105 5.105 0 0 0 4.796 5.397c5.629.333 10.461-3.961 10.793-9.59l.233-3.938a7.645 7.645 0 0 0-2.675-6.277l-3.02-5.249 9.373-3.063a19.914 19.914 0 0 0 8.082-5.016l-4.307.986a18.014 18.014 0 0 1-4.396 2.13L37.459 53.1l4.421 7.681Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.764 9.485c.182.232.358.468.53.708a6.533 6.533 0 0 0-.674.118l-.303.069c.172-.286.321-.586.447-.895Z",
    fill: "${color}"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.745 11.427 39.1 14.552a4.5 4.5 0 0 1-2.01-8.773l13.648-3.125a4.5 4.5 0 1 1 2.008 8.773Zm-13.2 5.074A6.5 6.5 0 0 1 36.644 3.83L50.29.704a6.5 6.5 0 0 1 2.902 12.672l-13.646 3.125Z",
    fill: "currentColor"
  })));
};
export default SvgNotApproval;